module.exports = __webpack_public_path__ + "img/step_two_brand_en.fcd1de55.png";